const MEGABYTE = 1024 * 1024

export const MAX_UPLOAD_FILE_SIZE = 50 * MEGABYTE
export const MAX_UPLOAD_IMAGE_SIZE = 5 * MEGABYTE

const isImageFile = (file: File) => file.type.startsWith('image/')

/**
 * Splits a chat upload batch by size limit: images get `MAX_UPLOAD_IMAGE_SIZE`,
 * every other file `MAX_UPLOAD_FILE_SIZE`.
 */
export const partitionFilesBySizeLimit = (files: File[]) => {
  const accepted: File[] = []
  const oversizedImages: File[] = []
  const oversizedFiles: File[] = []

  for (const file of files) {
    if (isImageFile(file)) {
      if (file.size > MAX_UPLOAD_IMAGE_SIZE) oversizedImages.push(file)
      else accepted.push(file)
      continue
    }
    if (file.size > MAX_UPLOAD_FILE_SIZE) oversizedFiles.push(file)
    else accepted.push(file)
  }

  return { accepted, oversizedImages, oversizedFiles }
}
